<!--  -->
<template>
  <div class="ContentBanner">
    <swiper
      :auto-update="true"
      class="maf-swiper"
      ref="mySwiper"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in BannerList"
        :key="index"
      >
        <img :src="item.Banner" />
        <!-- <div class="Banner-text">
          <h1>
            {{ item.Bannertext }}
          </h1>
          <h2>{{ item.BannerEn }}</h2>
        </div> -->
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" slot="button-prev" @click="prev"></div>
    <div class="swiper-button-next" slot="button-next" @click="next"></div>
    <div class="aaaaaa"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    //这里存放数据
    return {
      Banner: require("../assets/Banner.png"),
      Bannertext: "在全球范围内已经获得超过70 项专利",
      BannerEn: "It has obtained more than 70 patents worldwide",
      // BannerList: [
      //   // {
      //   //   Banner: require("../assets/Banner.png"),
      //   //   Bannertext: "在全球范围内已经获得超过70 项专利",
      //   //   BannerEn: "It has obtained more than 70 patents worldwide",
      //   // },
      //   // {
      //   //   Banner: require("../assets/Banner.png"),
      //   //   Bannertext: "在全球范围内已经获得超过70 项专利",
      //   //   BannerEn: "It has obtained more than 70 patents worldwide",
      //   // },
      //   // {
      //   //   Banner: require("../assets/Banner.png"),
      //   //   Bannertext: "在全球范围内已经获得超过70 项专利",
      //   //   BannerEn: "It has obtained more than 70 patents worldwide",
      //   // },
      // ],

      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,

        speed: 500,
        autoplay: this.BannerList.length > 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  props: {
    BannerList: {
      type: Array, // 定义接收到的数据的类型
      required: false, //规定这个数据是否必传,默认false
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
@import "../../scss/public.scss";
//@import url(); 引入公共css类
.ContentBanner {
  width: 100%;
  position: relative;
  // height: 460px;
  .maf-swiper {
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
  }
  .swiper-button-prev {
    width: 100px;
    height: 100px;
  }
  .swiper-button-next {
    width: 100px;
    height: 100px;
  }
  .Banner-text {
    width: 1200px;
    height: 120px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    color: $text-color;
    h1 {
      font-size: 2.4rem;
    }
    h2 {
      margin-top: 16px;
      font-size: 1.5rem;
      letter-spacing: 1px;
    }
  }
}
@media screen and (max-width: $main-width) {
  .ContentBanner {
    // height: 120px;
    .swiper-button-prev {
      width: 40px;
      height: 40px;
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ContentBanner.vue